import { render } from 'preact';
import './styles/tokens.css';
import { App } from './App';

const root = document.getElementById('app');
if (!root) throw new Error('#app root not found');
render(<App />, root);
